import { render } from "./theme38.vue?vue&type=template&id=119b598e&scoped=true"
import script from "./theme38.vue?vue&type=script&lang=js"
export * from "./theme38.vue?vue&type=script&lang=js"

import "./theme38.vue?vue&type=style&index=0&id=119b598e&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-119b598e"

export default script